export default __webpack_public_path__ + "static/media/gallery-sirius_00.28b1ab15.jpg";